// @ts-ignore
import * as ramda from 'ramda';
// @ts-ignore
import param from 'jquery-param';
import type {FilterObject} from '../types';

/**
 * Updates urlParams and returns the new search object
 *
 * Takes an object of parameters for a given key, merges it with existing
 * @param  {Object} oldUrlParams     - Existing url params to update /w new
 * @param  {Object} newParams        - New url parameters (i.e. {report: {gap: 'm'})
 * @param  {boolean} [shouldMerge]   - Should the parameters be merged to existing, or replace entirely?
 * @return {void}
 */
export function updateUrlParam(
    oldUrlParams: FilterObject,
    newParams: FilterObject,
    shouldMerge?: boolean
): string {
    let params;

    if (shouldMerge) {
        params = Object.keys(newParams).reduce(
            (paramAccum, paramKey) => {
                // $NutshellClientFlowIgnore upgrading Flow to v0.92.1
                paramAccum[paramKey] = {
                    // $NutshellClientFlowIgnore upgrading Flow to v0.92.1
                    ...paramAccum[paramKey],
                    ...newParams[paramKey],
                };

                return paramAccum;
            },
            {...oldUrlParams}
        );
    } else {
        params = {
            ...oldUrlParams,
            ...newParams,
        };
    }

    const cleanParams = stripUndefinedProperties(params);

    return param(cleanParams);
}

/**
 * Remove undefined and empty object properties
 *
 * @param  {Object} paramObject An object that will be paramed into a search string
 * @return {Object}             The same object, with all undefined values and empty objects removed.
 */
function stripUndefinedProperties(paramObject: any) {
    const strippedParams: Record<string, any> = {};
    // @ts-ignore
    function accumDefined(value, key) {
        if (typeof value === 'object' && !Array.isArray(value)) {
            const strippedParam = stripUndefinedProperties(value);
            if (Object.keys(strippedParam).length !== 0) {
                strippedParams[key] = stripUndefinedProperties(value);
            }
        } else if (typeof value !== 'undefined') {
            strippedParams[key] = value;
        }
    }
    ramda.forEachObjIndexed(accumDefined, paramObject);

    return strippedParams;
}
